import {
  LocalActionCounts,
  reduceActionCounts,
} from '@/experiences/sales-portal/domain/pricing-agent/blocs/utils/count-actions';
import { useMemo } from 'react';
import { useRecommendationActionsStore } from '@/experiences/sales-portal/domain/pricing-agent/blocs/stores/recommendation-actions-store';

/**
 * Tallies the active task type's local (unpublished) edits by action — what
 * Publish will submit. Shared by the footer's progress display and the top-bar
 * publish/undo actions.
 */
export const useLocalActionCounts = (): LocalActionCounts => {
  const actions = useRecommendationActionsStore((state) => state.actions);

  return useMemo(() => reduceActionCounts(actions), [actions]);
};
